interface PrimaryTitleInterface {
    label: string;
}

export function PrimaryTitle({label}: PrimaryTitleInterface) {
    return <div className={`text-[30px] font-bold`}>
        {label}
    </div>;
}